import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource';
import { DirectBankBrand } from '../../model/types/payment-method-type';

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.PL,
  regionId: 5905,
  defaultCountryFrom: 'PL',
  defaultCountryFromOnfido: 'POL',
  defaultCountryCodeFrom: 48,
  defaultCurrencyFrom: 'PLN',
  defaultLanguageCulture: 'pl-PL',
  defaultLocation: {
    latitude: 52.237049,
    longitude: 21.017532
  },
  dateFormat: 'DD/MM/YYYY',
  postalCodeRegex:`^\\d{2}-\\d{3}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['pl-PL', 'en-PL', 'ru-RU', 'uk-UA'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 1,
  directBankBrand: DirectBankBrand.Blik,
  distanceMetric: 'km',
  acceptInternationalCards:true,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: true,
  isEMEA: true,
  notShowMarketingPushAlert: false,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["cartes_bancaires", "masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/PL.ts